var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "betslip-tax-info-wrapper" }, [
    _vm.betslipConfig.winnings
      ? _c("div", { staticClass: "possible-winning" }, [
          _c("div", { staticClass: "label important" }, [
            _vm._v(" Possible winn "),
          ]),
          _c("div", { staticClass: "value important" }, [
            _vm._v(" " + _vm._s(_vm.meta.possibleWinning) + " "),
          ]),
        ])
      : _vm._e(),
    !_vm.taxDisabled
      ? _c("div", { staticClass: "taxes" }, [
          _c("div", { staticClass: "tax" }, [
            _c("div", { staticClass: "tax-label" }, [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("translate")("general_payin_tax")) +
                    " " +
                    _vm._s("(" + _vm.payinTax.policy.taxValue + "%)") +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "tax-value" }, [
              _c("span", [
                _vm._v(" " + _vm._s(_vm.payinTax.taxAmountRounded) + " "),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }